import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import '../RoomListItem/RoomListItem.css';
import ListEditButtons from '../ListEditButtons/ListEditButtons';
import ReservationList from "../ReservationList/ReservationList";

function RoomListItemAdmin(props) {

    let isHotelDetails = (props.hotelId === undefined && props.hotelName === undefined) ? true : false;

    let reservations = [];
    const roomReservations = props.reservations.map(reservation => {
        if (reservation.roomId === props.id) {
           reservations.push(reservation)
        }
    });
    return (

        <Fragment>


            <div className="card">
                <div className="row">

                    <img className="card-img-top col-lg-6"

                         src={(props.imageUrl && props.imageUrl.trim() !== "") ? props.imageUrl : "/images/noimage.png"}
                         alt="Room"/>

                    <div className="card-body col-lg-6 text-left">
                        <h4 className="card-title">{props.name}</h4>
                        <p><strong>Number of beds: </strong> {props.numberOfBeds}</p>
                        <p><strong>Price per nights: </strong> {props.pricePerNight} $</p>

                        <div>
                            <ListEditButtons
                                to={"/modify-room/" + props.id}
                                deleteHandler={props.deleteHandler}
                            />
                            <Link to={'/rooms/' + props.id} className="btn btn-primary btn-sm">
                                Go to room
                            </Link>

                        </div>


                    </div>
                </div>
            </div>

            <br/>

            <div>
                <ReservationList
                    isHotelDetails={isHotelDetails}
                    reservations={reservations}
                    reservationEdit={props.reservationEdit}
                    deleteHandler={props.deleteReservationHandler} />

            </div>
        </Fragment>


    )
}

export default RoomListItemAdmin;


// WEBPACK FOOTER //
// ./src/components/RoomListItemAdmin/RoomListItemAdmin.jsx